// ─── Attendance statuses ───────────────────────────────────────
// Mirrors the enum accepted by the API validators. See
// api/routes/rsvp.routes.mjs for the contract.

export const STATUS_VALUES = ["attending", "notAttending", "maybe"];

// i18n keys per status. Resolve via t(STATUS_LABEL_KEYS[status]) at render
// time so labels follow the active language.
export const STATUS_LABEL_KEYS = {
  attending: "rsvp.status.attending",
  notAttending: "rsvp.status.notAttending",
  maybe: "rsvp.status.maybe",
  pending: "rsvp.status.pending",
};

// Placeholder shown in the AttendanceSelector when the guest has not
// picked a status yet.
export const STATUS_PLACEHOLDER_KEY = "rsvp.status.placeholder";

// Status chip palette. Hue mirrors the original (76/175/80, 244/67/54,
// 255/152/0) — alphas are slightly bumped so the tints still read on
// the cream modal bg (#ece9e3) without going neon.
export const STATUS_COLORS = {
  attending: {
    bg: "rgba(76,140,82,0.18)",
    border: "rgba(76,140,82,0.6)",
    dot: "#5C8A60",
  },
  notAttending: {
    bg: "rgba(198,60,50,0.16)",
    border: "rgba(198,60,50,0.55)",
    dot: "#B4463C",
  },
  maybe: {
    bg: "rgba(214,138,40,0.18)",
    border: "rgba(214,138,40,0.55)",
    dot: "#C08236",
  },
  pending: {
    bg: "rgba(0,0,0,0.04)",
    border: "rgba(0,0,0,0.22)",
    dot: "#8a8a8a",
  },
};
